import { getVariantConfig } from './appVariant'

// The server's `environment` label (lib/serverAnalytics.js) as a super property
// on a browser tracker. PostHog keeps super properties in a cookie shared across
// *.infranodus.com, so a label registered on staging would follow the browser to
// production: an unlabelled instance clears it instead of leaving it alone.
export function registerAnalyticsEnvironment(tracker) {
    const environment = getVariantConfig().trackers?.analyticsEnvironment
    try {
        if (environment) tracker.register({ environment })
        else tracker.unregister('environment')
    } catch (ignored) {}
}

// The same call for the inline PostHog snippet, which runs before any bundle.
export function posthogEnvironmentCall(environment) {
    return environment
        ? `posthog.register(${JSON.stringify({ environment })});`
        : "posthog.unregister('environment');"
}
